module.exports = __webpack_public_path__ + "img/Bank Nobu.1b2194e2.png";